import {useSearchParams} from '@github-ui/use-navigate'
import {useEffect, type RefObject} from 'react'

export function useNewSessionEntrypoint(textAreaRef: RefObject<HTMLTextAreaElement | null>) {
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.get('new_session') !== '1') return

    textAreaRef.current?.focus()
    const nextSearchParams = new URLSearchParams(searchParams)
    nextSearchParams.delete('new_session')
    // Dropping the param is a real navigation, and the app focuses the page heading on
    // navigation, which would pull focus straight back out of the composer.
    setSearchParams(nextSearchParams, {replace: true, preventAutofocus: true})
  }, [searchParams, setSearchParams, textAreaRef])
}
